import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';
import '../styles/PerthPropertyPulseTile.css';

const TILE_BG = 'https://static.prod-images.emergentagent.com/jobs/8eb1e5b0-8e8c-4e88-832b-2916713b4c7a/images/8f805bc6ab39e384f2c328595edd52e08854bc00a8ec3acd4c5cfb14dd37c81e.png';

const PerthPropertyPulseTile = () => (
  <section className="ppt" data-testid="perth-property-pulse-tile">
    <div className="ppt-container">
      <Link to="/perth-property-pulse" className="ppt-card" data-testid="ppt-card-link">
        <div className="ppt-bg" style={{ backgroundImage: `url(${TILE_BG})` }} role="img" aria-label="A modern Perth home glowing at golden hour" />
        <div className="ppt-veil" />
        <div className="ppt-content">
          <span className="ppt-label"><MapPin size={13} /> New property intelligence portal</span>
          <h2 className="ppt-title">Perth Property Pulse</h2>
          <p className="ppt-body">
            A beautiful intelligence hub for Perth homeowners, buyers and sellers — covering property
            trends, planning updates, climate guidance, home care, waterwise gardens and local market insights.
          </p>
          <span className="ppt-cta" data-testid="ppt-cta">
            Explore Perth Property Pulse <ArrowRight size={16} />
          </span>
        </div>
      </Link>
    </div>
  </section>
);

export default PerthPropertyPulseTile;
